import React from 'react'
import PropTypes from 'prop-types'
import TableCell from '@material-ui/core/TableCell'
import TableHeadMaterialUi from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Tooltip from '@material-ui/core/Tooltip'

class TableHead extends React.Component {
  render() {
    const { order, orderBy, rows, extraColumn = true } = this.props

    return (
      <TableHeadMaterialUi>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                sortDirection={orderBy === row.id ? order : false}
              >
                <Tooltip
                  title={'Sort'}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={() => {
                      if (row.id === orderBy) {
                        const newOrder = order === 'asc' ? 'desc' : 'asc'

                        this.props.sortOn(row.id, newOrder, row.sortType)
                      } else {
                        this.props.sortOn(row.id, order, row.sortType)
                      }
                    }}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            )
          }, this)}
          {extraColumn ? <TableCell /> : null}
        </TableRow>
      </TableHeadMaterialUi>
    )
  }
}

TableHead.propTypes = {
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
}

export { TableHead }



// WEBPACK FOOTER //
// ./src/components/common/TableHead.js